export const MOBILE_FOOTER_HEIGHT = 56;
export const ROOT_MARGIN = '160px 0px';

export const DEFAULT_PAGE_NUMBER = 1;
export const DEFAULT_PAGE_SIZE = 50;
export const QUOTES_DEFAULT_PAGE_SIZE = 6;

export const DEFAULT_SEARCH_DEBOUNCE_TIME = 800;
